import React from "react";
import { HomeTitle } from "../components";
import { useTitle } from "../hooks";

const Error = () => {
  useTitle("Error");
  return (
    <div className="container" style={{ marginTop: "120px" }}>
      <img
        src="/assets/illustrations/error.svg"
        alt="sadFace"
        className="mx-auto w-72"
      />
      <HomeTitle title="something went wrong :(" center />
      <p className="text-center">
        Check the console for more technical explanation
        <br />
        Or
        <br />
        Contact us via:{" "}
        <a
          href="mailto:support@adsil.io"
          rel="noreferrer noopner"
          target="_blank"
          className="font-bold"
        >
          support@adsil.io
        </a>
      </p>
    </div>
  );
};

export default Error;
